import { array, arrayOf, bool, number, oneOf, regex, string } from "attr-types";

export { array, arrayOf, bool, number, oneOf, regex, string };
export default {
  array,
  arrayOf,
  bool,
  number,
  oneOf,
  regex,
  string,
};
